var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "no-results",
      class: {
        mobile: _vm.mobile,
        desktop: !_vm.mobile
      }
    },
    [
      _c("p", [
        _vm._v("We couldn't find what you were looking for in our courses.")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }